import { BASE_URL } from "@/lib/constants";

interface SeoConfig {
	title: string;
	description: string;
	url: string;
	image?: string;
	type?: "website" | "article";
	siteName?: string;
	keywords?: string | string[];
}

const DEFAULT_CONFIG = {
	siteName: "Craftlayer",
	image: `${BASE_URL}/og-image.jpg`,
	type: "website" as const,
};

export const generateSeo = (config: SeoConfig) => {
	const {
		title,
		description,
		url,
		image = DEFAULT_CONFIG.image,
		type = DEFAULT_CONFIG.type,
		siteName = DEFAULT_CONFIG.siteName,
		keywords,
	} = config;

	const cleanUrl = `${url.replace(/\/$/, "")}/`;
	const fullUrl = cleanUrl.startsWith("http")
		? cleanUrl
		: `${BASE_URL}${cleanUrl}`;

	return {
		meta: [
			{ title },
			{ name: "description", content: description },
			...(keywords && keywords.length > 0
				? [
						{
							name: "keywords",
							content: Array.isArray(keywords) ? keywords.join(", ") : keywords,
						},
					]
				: []),
			// Open Graph
			{ property: "og:type", content: type },
			{ property: "og:site_name", content: siteName },
			{ property: "og:title", content: title },
			{ property: "og:description", content: description },
			{ property: "og:url", content: fullUrl },
			{ property: "og:image", content: image },
			// Twitter
			{ name: "twitter:card", content: "summary_large_image" },
			{ name: "twitter:site", content: "@craftlayer" },
			{ name: "twitter:title", content: title },
			{ name: "twitter:description", content: description },
			{ name: "twitter:image", content: image },
		],
		links: [{ rel: "canonical", href: fullUrl }],
	};
};
